<template>
  <v-app>
    <v-app-bar  app color="black" dark>
      <div>
        <v-subheader>{{ vendorName }}</v-subheader>
        <v-toolbar-title>{{ selectedTab }}</v-toolbar-title>
      </div>
      <v-spacer></v-spacer>

          <template v-if="$vuetify.breakpoint.mdAndUp">
      <v-menu  top offset-y content-class="custom-menu-content" open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on"> Trips </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, index) in tripItems" :key="index" @click="redirect(item.title)">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-menu top offset-y content-class="custom-menu-content" open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <v-btn text v-bind="attrs" v-on="on"> Transport </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, index) in transportItems" :key="index" @click="redirect(item.title)">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <v-btn text @click="redirect('Reports')">Reports</v-btn>
      <v-btn text @click="redirect('Admin')">Admin</v-btn>
      <!-- v-if="vendorName === 'MALIKTRANSPORTBLR'" -->
      <v-btn v-if="$isIndigo==='true'" text @click="redirect('Billing')">Billing</v-btn>
      <v-btn text @click="redirect('Account')">Profile</v-btn>

      <v-spacer></v-spacer>
</template>
   <template v-else>
      <v-menu left offset-y   content-class="custom-menu-zindex">
        <template v-slot:activator="{ on, attrs }">
          <v-btn icon v-bind="attrs" v-on="on">
            <v-icon>mdi-menu</v-icon>
          </v-btn>
        </template>

        <v-list>
          <v-list-item v-for="(item, index) in [...tripItems, ...transportItems]" :key="index" @click="redirect(item.title)">
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>

          <v-divider></v-divider>
          <v-list-item @click="redirect('Reports')"><v-list-item-title>Reports</v-list-item-title></v-list-item>
          <v-list-item @click="redirect('Admin')"><v-list-item-title>Admin</v-list-item-title></v-list-item>
          <v-list-item @click="redirect('Billing')"><v-list-item-title>Billing</v-list-item-title></v-list-item>
          <v-list-item @click="redirect('Account')"><v-list-item-title>Profile</v-list-item-title></v-list-item>
        </v-list>
      </v-menu>
    </template>


      <!-- <span>{{ selectedTab }}</span>

      <v-menu bottom offset-y content-class="custom-menu-content" open-on-hover>
        <template v-slot:activator="{ on, attrs }">
          <div class="user-info" v-on="on" v-bind="attrs"><span>SP</span></div>
        </template>
      </v-menu> -->

      <div v-if="$isIndigo" class="action-bar">
        <v-autocomplete
          v-model="branch"
          :items="branchList"
          color="white"
          item-text="name"
          item-value="id"
          label="Station"
          required
          dense
          class="white-select custom-width"
          hide-details
          :return-object="true"
        ></v-autocomplete>

        <v-tooltip bottom color="#3a3b3b">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#DD9504" @click="logout" v-on="on" v-bind="attrs">
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#FFFFFF">
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
              </svg>
            </v-btn>
          </template>
          <span>Logout</span>
        </v-tooltip>
      </div>
      <div v-else class="action-bar">
        <v-autocomplete
          v-model="branch"
          :items="branchList"
          color="white"
          item-text="name"
          item-value="id"
          label="Branch"
          required
          dense
          class="white-select custom-width"
          hide-details
          :return-object="true"
        ></v-autocomplete>

        <v-tooltip bottom color="#3a3b3b">
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="#DD9504" @click="logout" v-on="on" v-bind="attrs">
              <svg xmlns="http://www.w3.org/2000/svg" height="20px" viewBox="0 0 24 24" width="20px" fill="#FFFFFF">
                <path d="M0 0h24v24H0z" fill="none" />
                <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z" />
              </svg>
            </v-btn>
          </template>
          <span>Logout</span>
        </v-tooltip>
      </div>
    </v-app-bar>
    <Confirm ref="confirm"></Confirm>
  </v-app>
</template>

<script>
import Confirm from "@/components/common/Confirm";
import instance from "@/axios/axios-global";
export default {
  name: "Sidebar",
  components: { Confirm },
  data() {
    return {
      drawer: true, //
      transportItems: [{ title: "Driver Management" }, { title: "Vehicle Management" }], //

      vendorName: "",

      selectedTab: "To be Approved",

      branchList: [],
      branch: null,
      tab: 0,
    };
  },
  computed: {
    tripItems() {
      const allTripItems = [
        { title: "Trip History", indigoOnly: false },
        { title: "To be Approved", indigoOnly: true },
        { title: "To be Assigned", indigoOnly: false },
        { title: "Last Minute Pullout", indigoOnly: true },
        { title: "Cancellation Pending", indigoOnly: true },
        { title: "Cancelled Trips", indigoOnly: false },
      ];

      return this.$isIndigo === 'true' ? allTripItems : allTripItems.filter((item) => !item.indigoOnly);
    }
  },
  mounted() {
    if (this.$isIndigo==='true')
    {
      this.selectedTab = "To be Approved";
      this.tab = 1;
    } else {
      this.selectedTab = "To be Assigned";
      this.tab = 0;
    }
    this.vendorName = localStorage.getItem("vendorName");

    const savedTab = localStorage.getItem("selectedTab");
    const tabs = ["Trip History", "To be Approved", "To be Assigned",'Last Minute Pullout', "Cancellation Pending", "Cancelled Trips", "Driver Management", "Vehicle Management", "Reports", "Admin", "Account", "Billing"];
    if (savedTab && tabs.some((item) => item === savedTab)) {
      this.selectedTab = savedTab;
    }

    this.$emit("selected-tab", { title: this.selectedTab, tab: this.tab });
    const branchListFromStorage = localStorage.getItem("branchList");
    try {
      this.branchList = branchListFromStorage ? JSON.parse(branchListFromStorage) : [];
    } catch (error) {
      console.error("Error parsing branchList from localStorage:", error);
      this.branchList = [];
    }

    if (this.branchList.length > 0) {
      const savedBranch = localStorage.getItem("selectedBranch");
      if (savedBranch) {
        const savedBranchData = JSON.parse(savedBranch);
        this.branch = this.branchList.find((branch) => branch.id === savedBranchData.id) || this.branchList[0];
      } else {
        this.branch = this.branchList[0];
      }
    }
  },
  watch: {
    selectedTab(newVal) {
      localStorage.setItem("selectedTab", newVal);
    },
    branch(newBranch) {
      if (newBranch) {
        localStorage.setItem("selectedBranch", JSON.stringify(newBranch));
      }
    },
  },
  methods: {
    redirect(title) {
      this.selectedTab = title;
      this.tab += 1;
      this.$emit("selected-tab", { title, tab: this.tab });
    },
    async logout() {
      let confirmTitle = "Confirm Logout";
      let confirmText = "Please Confirm to Logout";
      let confirmIcon = "fas fa-exclamation";
      if (
        await this.$refs.confirm.open(confirmTitle, confirmText, {
          icon: confirmIcon,
          color: "red",
          buttonName: "Logout",
        })
      ) {
        instance.defaults.headers.common["token"] = "";

        localStorage.removeItem("vendorLoginToken");
        localStorage.removeItem("vendorName");
        localStorage.removeItem("vendorNumber");
        localStorage.removeItem("vendorStatus");
        localStorage.removeItem("selectedBranch");
        localStorage.removeItem("branchList");
        localStorage.removeItem("selectedTab");
        localStorage.removeItem("ownerId");

        await this.$router.push("/login");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@media screen and (max-width: 1024px) {
  ::v-deep .v-app-bar {
  // background-color: #ffff !important;
overflow-x: auto !important;
}
// ::v-deep .custom-menu-zindex {
//   z-index: 2000 !important; 
// }
}

  .custom-menu-zindex {
color: rgba(0, 0, 0, 0.87)  !important;
    z-index: 999 !important;



    .v-list-item__title{
    font-size: 13px !important;
    font-weight: 600 !important;
    cursor: pointer !important;
    }
  }


.fas {
  margin-left: 3px;
}

.action-bar {
  display: flex;
  gap: 10px;
  align-items: center;


@media  screen and (max-width: 1024px) {
  .custom-width{
    width: 100px !important;
  }
}

}

.custom-menu-content {
  top: 50px !important;
  z-index: 10 !important;
  .v-list-item__title {
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
  }
}

.v-list-item {
  text-align: center;
  border-bottom: 1px solid #eaeaea;

  &:last-child {
    border-bottom: none;
  }
}

.v-toolbar__title {
  text-transform: uppercase;
  width: 250px;
  font-size: 1.15rem;
}

.user-info {
  width: 40px;
  height: 40px;
  background: #ffbb3c;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  span {
    color: #000;
    font-weight: bold;
  }
}

.v-subheader {
  height: auto;
  padding: 0;
}
  



</style>
